import React from 'react'
import { useEffect } from 'react';
import Swiper from 'swiper';
import SingleServicesImg1 from "../assets/images/services/single-services1.jpg"
import SingleServicesImg2 from "../assets/images/services/single-services2.jpg"
import SingleServicesImg3 from "../assets/images/services/single-services3.jpg"
import VisionBoxImg from "../assets/images/about/vision-box-img.jpg"
import Services2Img5 from "../assets/images/services/sevices2img5.jpg"
import Services2Img6 from "../assets/images/services/sevices2img6.jpg"
import FixHeader from '../component/FixHeader'
import Loader from '../component/Loader'
import LatestBlog from '../component/LatestBlog'
import Footer from '../component/Footer'
import { useNavigate } from 'react-router-dom';

const ServicesDeatils3 = () => {
    const navigate = useNavigate()
    useEffect(() => {
        new Swiper(".single-slider", {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            speed: 1600,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
        });
    }, []);
    return (
        <>
            <Loader />
            <FixHeader />
            {/* <!-- ====================================== Services Section One ===================================== --> */}
            <section className="section-breadcrumb-img" id="about-section-one">
                <div className="container breadcrumb-main">
                    <h1 className="about-h1-text" data-aos="fade-down">Single Services</h1>
                    <ul className="breadcrumb-list about-breadcrumb" data-aos="fade-up">
                        <li className="line-slash" onClick={() => navigate("/")}>Home</li>
                        <li className="line-slash" onClick={() => navigate("/ServicesDetails3")}>Services</li>
                        <li className="active-breadcrumb" onClick={() => navigate("/ServicesDetails3")}>Single Services 3</li>
                    </ul>
                </div>
            </section>
            {/* <!-- ====================================== Services Section Two ===================================== --> */}
            <section className="about-section-two pb-0">
                <div className="container">
                    <div className="row single-services3-row">
                        <div className="col-xxl-8 col-xl-8 col-lg-12 col-md-12">
                            <div className="swiper single-slider">
                                <div className="swiper-wrapper ">
                                    <div className="swiper-slide">
                                        <img className="single-services1" data-aos="fade-down" src={SingleServicesImg1} alt="single-services1" />
                                    </div>
                                    <div className="swiper-slide">
                                        <img className="single-services1" data-aos="fade-down" src={SingleServicesImg2} alt="single-services1" />
                                    </div>
                                    <div className="swiper-slide">
                                        <img className="single-services1" data-aos="fade-down" src={SingleServicesImg3} alt="single-services1" />
                                    </div>
                                    <div className="swiper-slide">
                                        <img className="single-services1" data-aos="fade-down" src={SingleServicesImg1} alt="single-services1" />
                                    </div>
                                </div>
                            </div>
                            <h2 className="Singleservices-text-main ">Web Copywriter</h2>
                            <p className="commodo">Commodo semper bibendum adipiscing orci bibendum eu lectus sed. Commodo
                                cursus vitae augue luctus nibh. Congue sit quisque volutpat libero tempor a id cursus purus.
                                Pellentesque pellentesque scelerisque curabitur porta dolor. Amet vulputate vitae eget sit
                                rhoncus imperdiet. Odio justo nullam scelerisque quis bibendum. Cras ipsum vel diam praesent
                                tortor at elit sit. A risus molestie bibendum donec blandit adipiscing volutpat sollicitudin
                                aliquam. Nec arcu cras ultrices velit sed ligula. Iaculis elit vulputate sollicitudin
                                quisque ut faucibus.</p>
                            <p className="commodo pt-2">Facilisis nec malesuada enim viverra cras. Auctor dignissim tellus
                                vestibulum vitae hac amet. Suspendisse sit feugiat in pulvinar bibendum arcu nunc id. Duis
                                hac nisl dui facilisi placerat at mauris elit scelerisque. Turpis ornare auctor amet
                                vestibulum in magna aliquet ultricies netus. Adipiscing lobortis a interdum morbi etiam non.
                                Elit sed magna risus tempor non quis. Nec pulvinar scelerisque in faucibus.</p>
                            <div className="check-list-main-grid">
                                <div className="img-animation-style4 reveal">
                                    <img className="vision-box-img2" src={VisionBoxImg} alt="vision-box-img" />
                                </div>
                                <div>
                                    <h3 className="check-list" data-aos="fade-up">Content Write Checklist</h3>
                                    <ul className="why-choose-list p-0" data-aos="fade-up">
                                        <li>We Create High Quality Content.</li>
                                        <li>We Focus on Well Organize Content.</li>
                                        <li>We Deliver On Time.</li>
                                        <li>We have best writer resources.</li>
                                        <li className="mb-0">Content Campaigns.</li>
                                    </ul>
                                </div>
                            </div>
                            <p className="commodo">Tortor quam congue habitasse egestas facilisi quis feugiat. Leo semper
                                quisque ipsum felis feugiat dolor erat. Pellentesque sit a pellentesque sed amet ac ipsum
                                ac. Leo eget at ultricies varius. Leo facilisis nec malesuada posuere nulla aliquet sed
                                purus dolor. Sit parturient varius egestas et ut orci viverra venenatis. Arcu enim ut
                                malesuada orci sit mattis a lectus. Cursus penatibus fusce et vel nullam. Auctor non laoreet
                                nibh tellus consequat risus nibh volutpat. Neque volutpat amet varius at eget lectus.</p>
                            <div className="single-services-imgs-group img-animation-style1 reveal active">
                                <img src={Services2Img5} alt="sevices2img5" />
                                <img src={Services2Img6} alt="sevices2img6" />
                            </div>
                            <p className="commodo">Facilisis nec malesuada enim viverra cras. Auctor dignissim tellus vestibulum
                                vitae hac amet. Suspendisse sit feugiat in pulvinar bibendum arcu nunc id. Duis hac nisl dui
                                facilisi placerat at mauris elit scelerisque. Turpis ornare auctor amet vestibulum in magna
                                aliquet ultricies netus. Adipiscing lobortis a interdum morbi etiam non. Elit sed magna
                                risus tempor non quis. Nec pulvinar scelerisque in faucibus.</p>
                            <p className="commodo pt-2">Dis morbi cursus aliquam rutrum tortor amet. Mauris consequat libero
                                praesent pellentesque nibh sed eget urna. Leo at feugiat vel dictum eget quam et commodo
                                nullam. Nec arcu egestas adipiscing mollis dapibus justo non.</p>
                        </div>
                    </div>
                </div>
            </section>
            <LatestBlog />
            <Footer />
        </>
    )
}

export default ServicesDeatils3